export const safeGetProjectName = () => {
  var _window;
  return window && ((_window = window) === null || _window === void 0 || (_window = _window.hubspot) === null || _window === void 0 || (_window = _window.bender) === null || _window === void 0 ? void 0 : _window.currentProject);
};